import { AutoInspector } from "@aet/react-inspector"
import { css } from "@emotion/css"
import { BreadcrumbItem, Breadcrumbs, Input } from "@heroui/react"
import { t } from "@lingui/core/macro"
import { get } from "es-toolkit/compat"
import JSON5 from "json5"
import { memo, useMemo, useState } from "react"

export const JSONView = memo(
  ({
    name,
    data,
    className,
    minimal,
    parse,
  }: {
    name?: string
    data: any
    className?: string
    minimal?: boolean
    parse?: boolean
  }) => {
    const [search, setSearch] = useState("")
    const parsed = useMemo(() => (parse ? JSON5.parse(data) : data), [data, parse])

    const result = useMemo(() => {
      if (!search) return parsed

      try {
        const result = get(parsed, search.replace(/^\./, ""))
        if (result !== undefined) {
          return result
        }
      } catch {}
      return parsed
    }, [parsed, search])

    return (
      <div className="ml-1 flex flex-col">
        {!minimal && false && (
          <Breadcrumbs css="mb-2 ml-1">
            <BreadcrumbItem>Home</BreadcrumbItem>
            <BreadcrumbItem>Document</BreadcrumbItem>
          </Breadcrumbs>
        )}
        <div className={className} css="min-h-24 flex-1 font-mono">
          <AutoInspector
            sortObjectKeys
            data={result}
            expandLevel={3}
            expandPaths={[]}
            name={search || name}
            showNonEnumerable={false}
            table={false}
          />
        </div>
        {!minimal && (
          <div css="mt-2">
            <Input
              className="w-full"
              placeholder={t`Evaluate`}
              value={search}
              variant="bordered"
              classNames={{
                inputWrapper: css`
                  border-width: 1px;
                `,
              }}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
        )}
      </div>
    )
  }
)
